import { useQuery } from "react-query";
import { getOfficeDarkReason } from "../../../../actions/Utilities/OfficeDarkReason";

let officeDarkOffice = [];
export const useGetOfficeDarkReason = () => {
  const { data } = useQuery("OfficeDarkReason", getOfficeDarkReason, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      if (res) {
        if (res.statusCode === 500 || res.statusCode === 400) {
        } else {
          officeDarkOffice = [];
          res.map((resData) => {
            officeDarkOffice.push({
              label: resData.darkReason,
              value: resData.darkReason,
            });
          });
        }
      }
    },
  });

  return officeDarkOffice;
};
